import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import { CalendarTicket } from "../models/calendar/calendar-ticket.interface";

@Injectable({
  providedIn: "root",
})
export class CalendarService {
  constructor(private http: HttpClient) {}

  createTicket(): Observable<CalendarTicket> {
    return this.http.post<CalendarTicket>(
      `${environment.APP_PORT + Constants.CALENDAR_TICKET_ENDPOINT}`,
      null
    );
  }
}
